import { logoutChamomile } from '@edu-frontend/modules/src/shared/lib/student';

import { wizardReducer, dictationReducer } from 'platform-components';
import { awardsReducer } from 'platform-components/src/components/awards/actions';
import notificationsReducer from 'platform-components/src/components/notifications/reducers';
import { quizReducer } from 'platform-components/src/components/quiz/slice';
import PropTypes from 'prop-types';
import React from 'react';
import { OnboardingModal } from '@edu-frontend/modules/src/shared/ui/OnboardingModal';
import { ProductTourModal } from '@edu-frontend/modules/src/features/productTour';

import { reducer as authorizationReducer } from 'common.components/authorization-modal/actions';
import { certificateModalReducer } from 'common.components/certificate-modal/reducer';
import certificatesReducer from 'common.components/certificates/reducer';
import { chatWidgetReducer } from 'common.components/chat-widget/actions';
import classesReducer from 'common.components/classes/reducer.ts';
import closingLessonModalReducer from 'common.components/closing-lesson-modal/reducer';
import { reducer as copyLessonModalReducer } from 'common.components/copy-lesson-modal/actions';
import { customLessonInfoModalReducer } from 'common.components/custom-lesson-info-modal/actions';
import { howToStartModalReducer } from 'common.components/how-to-start-modal/reducer';
import { reducer as lessonReducer, deleteCLessonReducer } from 'common.components/lesson';
import { lessonContentReducer } from 'common.components/lesson-content/actions';
import assignLessonReducer from 'common.components/lesson-view.assignment/reducer';
import { reducer as lessonViewSidePanelReducer } from 'common.components/lesson-view.side-panel/actions';
import lessonViewReducer from 'common.components/lesson-view.store/reducer';
import { subscriptionModalReducer } from 'common.components/lesson-view.subscription-modal/actions';
import { personalDataModalReducer } from 'common.components/personal-data-modal/actions';
import { resultsReducer } from 'common.components/results/actions';
import salesCodeModalReducer from 'common.components/sales-code-modal/reducer';
import schoolFormReducer from 'common.components/school-form/reducers';
import studentsReducer from 'common.components/students/reducer';
import { teamBuilderReducer } from 'common.components/team-builder/actions';
import { reducer as courseContainerWidgetReducer } from 'common.components/widgets.course-container/actions';
import { calendarPlanReducer } from 'store/calendar-plan/actions';
import { clessonResultsReducer } from 'store/clesson-results/actions';
import { clessonsReducer } from 'store/clessons/actions';
import courseStatsReducer from 'store/course-stats/reducers';
import coursesTemplatesReducer from 'store/courses-templates/reducers';
import { reducer as coursesReducer } from 'store/courses/actions';
import { diagnosticsReducer } from 'store/diagnostics/actions';
import { externalLmsConnectReducer } from 'store/external-lms-connect/actions';
import { likesReducer } from 'store/likes/actions';
import { mainPageReducer } from 'store/main-page/actions';
import { prepLessonsReducer } from 'store/prep-lessons/actions';
import { reducer as problemsViewReducer } from 'store/problems-view/actions';
import problemsReducer from 'store/problems/reducer';
import { referralCodeReducer } from 'store/referral-code/actions';
import { stickersReducer } from 'store/stickers/actions';
import studentClessonResultReducer from 'store/student-clesson-result/reducers';
import { courseSubscriptionsReducer } from 'store/subscriptions/actions';
import teacherCoursesByClassReducer from 'store/teacher-courses/reducers';
import themesReducer from 'store/themes/reducers';

import { useBunkerProductTour } from 'hooks/useBunkerProductTour';
import classReducer from '../class/reducer.ts';
import { reducer as courseCalendarReducer } from '../course-calendar/actions';
import courseViewReducer from '../course-view/reducer';
import { reducer as examsResultsReducer } from '../exams-results/actions';
import { reducer as lessonWidgetReducer } from '../lesson-editor-widget/actions';
import { reducer as libraryUpdatesModalReducer } from '../library-updates-modal/actions';
import { calendarPlanShowcaseReducer } from '../library.calendar-plan-showcase/actions';
import { reducer as libraryCourseContainerReducer } from '../library.course-container/actions';
import libraryReducer from '../library.store/reducer';
import newYearModalReducer from '../new-year-modal/reducer';
import { teacherOpenCertificatesReducer } from '../portfolio/actions';
import { quizEditorReducer } from '../quiz-editor/actions';
import { specCourseReducer } from '../spec-course.store/actions';
import { teacherCertificateModalReducer } from '../teacher-certificate-modal/actions';
import TeacherPage from '../teacher-page/teacher-page';
import { teacherKPKsReducer } from '../teacher-kpks-page';
import UMKModalReducer from '../umk-modal/reducer';
import { getMetrilaCallbacks } from './getMetrilaCallbacks';

class TeacherAppComponent extends React.Component {
    static contextTypes = {
        store: PropTypes.object.isRequired,
    };

    UNSAFE_componentWillMount() {
        const { store } = this.context;

        store.addReducers({
            authorizationModal: authorizationReducer,
            lessonAssignment: assignLessonReducer,
            class: classReducer,
            classes: classesReducer,
            certificatesModal: certificateModalReducer,
            courseView: courseViewReducer,
            courseCalendar: courseCalendarReducer,
            courses: coursesReducer,
            lesson: lessonReducer,
            deleteCLesson: deleteCLessonReducer,
            dictation: dictationReducer,
            wizard: wizardReducer,
            personalDataModal: personalDataModalReducer,
            students: studentsReducer,
            UMKModal: UMKModalReducer,
            newYearModal: newYearModalReducer,
            howToStartModal: howToStartModalReducer,
            library: libraryReducer,
            libraryCourseContainer: libraryCourseContainerReducer,
            libraryUpdatesModal: libraryUpdatesModalReducer,
            lessonView: lessonViewReducer,
            problemsView: problemsViewReducer,
            lessonViewSidePanel: lessonViewSidePanelReducer,
            lessonResults: resultsReducer,
            prepLessons: prepLessonsReducer,
            problems: problemsReducer,
            closingLessonModal: closingLessonModalReducer,
            salesCodeModal: salesCodeModalReducer,
            coursesTemplates: coursesTemplatesReducer,
            teacherCoursesByClass: teacherCoursesByClassReducer,
            courseStats: courseStatsReducer,
            certificates: certificatesReducer,
            notifications: notificationsReducer,
            studentClessonResult: studentClessonResultReducer,
            themes: themesReducer,
            chatWidget: chatWidgetReducer,
            lessonWidget: lessonWidgetReducer,
            copyLessonModal: copyLessonModalReducer,
            externalLmsConnect: externalLmsConnectReducer,
            subscriptionModal: subscriptionModalReducer,
            subscriptions: courseSubscriptionsReducer,
            diagnostics: diagnosticsReducer,
            schoolForm: schoolFormReducer,
            specCourse: specCourseReducer,
            customLessonInfoModal: customLessonInfoModalReducer,
            referralCode: referralCodeReducer,
            calendarPlanShowcase: calendarPlanShowcaseReducer,
            teacherCertificateModal: teacherCertificateModalReducer,
            awards: awardsReducer,
            lessonContent: lessonContentReducer,
            likes: likesReducer,
            teamBuilder: teamBuilderReducer,
            teacherCertificates: teacherOpenCertificatesReducer,
            teacherKPKs: teacherKPKsReducer,
            stickers: stickersReducer,
            clessonResults: clessonResultsReducer,
            clessons: clessonsReducer,
            quizEditor: quizEditorReducer,
            quiz: quizReducer,
            mainPage: mainPageReducer,
            calendarPlan: calendarPlanReducer,
            courseContainerWidget: courseContainerWidgetReducer,
            examsResults: examsResultsReducer,
        });
    }

    componentDidMount() {
        logoutChamomile();
    }

    render() {
        const { next } = this.props;

        const callbacks = getMetrilaCallbacks({ next });

        return (
            <>
                <TeacherPage />
                <OnboardingModal />
                <ProductTourModal {...callbacks} />
            </>
        );
    }
}

function TeacherApp() {
    const { next } = useBunkerProductTour({ name: 'teacher-onboarding' });

    return <TeacherAppComponent next={next} />;
}

export default TeacherApp;
